import { render, staticRenderFns } from "./CanvasWithSizeDrawing.vue?vue&type=template&id=1ce48ad5&scoped=true&"
import script from "./CanvasWithSizeDrawing.vue?vue&type=script&lang=js&"
export * from "./CanvasWithSizeDrawing.vue?vue&type=script&lang=js&"
import style0 from "./CanvasWithSizeDrawing.vue?vue&type=style&index=0&id=1ce48ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce48ad5",
  null
  
)

export default component.exports